import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { cognitoAuthConfig } from './aws-config';
import { AuthHandler } from './AuthHandler';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage } from 'aws-amplify/utils';

Amplify.configure({
  Auth: {
    Cognito: cognitoAuthConfig,
  },
});

cognitoUserPoolsTokenProvider.setKeyValueStorage(
  new CookieStorage({ secure: true, sameSite: 'strict' })
);

function renderApp(): void {
  ReactDOM.render(
    <React.StrictMode>
      <Router>
        <AuthHandler />
      </Router>
    </React.StrictMode>,
    document.getElementById('root')
  );
}

renderApp();
